import { useState, useEffect } from 'react';
import { useStore } from '@betgames/bg-state-manager';
import { useMounted } from '@betgames/bg-tools';
import { authStore } from '@bg-shared/business/Auth';
import { IBettingLimitsResponseFormatted, IBettingLimitsParams } from '../interfaces';
import { bettingLimitsApi } from '../BettingLimits.api';
import { bettingLimitsFormatter } from '../BettingLimits.formatter';

// https://betgamestv.atlassian.net/wiki/spaces/DEVEL/pages/12079651/Limits+handling+in+classic+iframe
export const useBettingLimits = (params: IBettingLimitsParams) => {
    const mounted = useMounted();
    const authorized = useStore(authStore);
    const [validation, setValidation] = useState<IBettingLimitsResponseFormatted>(
        bettingLimitsFormatter.defaultValidation,
    );
    const dependency = params.options
        ?.map((option) => [option.id, option.runId, option.runRoundId, option.items?.join('.')])
        .flat()
        .join('.');

    useEffect(() => {
        if (!params.options?.length || !authorized) {
            setValidation(bettingLimitsFormatter.defaultValidation);
            return;
        }

        bettingLimitsApi.getLimitsWithDebounce(params).then((data) => {
            if (mounted.current) {
                setValidation(data);
            }
        });
    }, [dependency, authorized]);

    return validation;
};
